import { transformTargetInfoArrayToObject } from '@/services/targetingInfo/transformers';
import { isClosed, setClose } from '@/services/targetingInfo/dataFilling';
import {
  SET_DISPLAY_DATA,
  STASH_TARGETING_INFO_CHANGES,
  SET_SAVING_STATUS,
  CLOSE_DATA_FILLING_HINT,
  SET_USER_SEGMENTS,
  CLEAR_TARGETING_INFO,
} from './mutationTypes';
import initialState from './initialState';

export default {
  [SET_DISPLAY_DATA](store, displayData) {
    store.displayData = displayData || [];
  },
  [STASH_TARGETING_INFO_CHANGES](store, updates) {
    store.data = { ...store.data, ...updates };
  },
  [SET_SAVING_STATUS](store, value) {
    if (!store.saved && value) {
      setClose(false);
      store.showDataFillingHint = true;
    }
    store.saved = value;
  },
  [CLOSE_DATA_FILLING_HINT](store) {
    setClose(true);
    store.showDataFillingHint = false;
  },
  [SET_USER_SEGMENTS](store, userSegments) {
    store.userSegments = userSegments || [];
    store.data = transformTargetInfoArrayToObject(store.userSegments);
    store.saved = true;
    store.showDataFillingHint = !isClosed();
  },
  [CLEAR_TARGETING_INFO](store) {
    Object.assign(store, initialState);
  },
};
